import { RootState } from '../../types';

export const isUpdatePromptModalOpen = (state: RootState) => state.app.updatePromptIsOpen;
export const getWorkboxInstance = (state: RootState) => state.app.workboxInstance;